const FATAL_ERROR_TITLE = 'Failed to start the application'
const RELOAD_LABEL = 'Reload'

export const showFatalErrorInApp = (message: string): void => {
  const root = document.getElementById('app')
  if (!root) {
    return
  }

  root.replaceChildren()

  const container = document.createElement('div')
  container.style.display = 'flex'
  container.style.minHeight = '100vh'
  container.style.alignItems = 'center'
  container.style.justifyContent = 'center'
  container.style.padding = '24px'
  container.style.fontFamily = 'system-ui, sans-serif'
  container.style.textAlign = 'center'

  const content = document.createElement('div')

  const title = document.createElement('p')
  title.textContent = FATAL_ERROR_TITLE
  title.style.fontSize = '18px'
  title.style.fontWeight = '600'
  title.style.margin = '0 0 12px'

  const description = document.createElement('p')
  description.textContent = message
  description.style.margin = '0 0 20px'
  description.style.wordBreak = 'break-word'

  const reloadButton = document.createElement('button')
  reloadButton.type = 'button'
  reloadButton.textContent = RELOAD_LABEL
  reloadButton.style.padding = '12px 24px'
  reloadButton.style.fontSize = '16px'
  reloadButton.style.cursor = 'pointer'
  reloadButton.addEventListener('click', () => {
    document.location.reload()
  })

  content.append(title, description, reloadButton)
  container.append(content)
  root.append(container)
}
